<template>
  <div id='header' :class="{ 'header__partnerA2G': isPartnerA2G }">
  <b-navbar toggleable="lg"
      type="dark"
      :variant="changeHeader ? 'info' : 'info-positivo'">
    <b-container>
      <a :href="[ isPartnerA2G ? 'https://a2g.ciclic.com.br/' : 'https://www.ciclic.com.br/' ]">
        <b-navbar-brand v-if="isPartnerA2G" class="ciclic-logoControl partnerA2G">
          <span class="partnerA2G__slug">um parceiro Ciclic</span>
        </b-navbar-brand>
        <b-navbar-brand v-else class="ciclic-logoControl ciclic-positivo">
        </b-navbar-brand>
      </a>
    </b-container>
  </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      isPartnerA2G: this.$partner === 'a2g',
      changeHeader: false,
      routeHeaderActive: true
    }
  },
  mounted () {
    this.checkUrl()
  },
  methods: {
    checkUrl () {
      this.changeHeader = this.$route.name === 'Home'
    },
    toggleHeader () {
      if (this.$route.name === 'Home') {
        this.changeHeader = !this.changeHeader
      }
    },
    toAnchor (anchor) {
      return this.$route.name === 'Home'
        ? anchor
        : `/${anchor}`
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        switch (to.path) {
          case '/cadastro':
            this.routeHeaderActive = false
            break
          case '/cadastro/endereco':
            this.routeHeaderActive = false
            break
          case '/cadastro/pagamento':
            this.routeHeaderActive = false
            break
          case '/cadastro/confirmacao':
            this.routeHeaderActive = false
            break
          default:
            this.routeHeaderActive = true
            break
        }
      },
      immediate: true
    }
  }
}
</script>
<style src="./Header.css"></style>
